/** Resolved Access Review live vs snapshot horizon (TROC-352). */
export interface AccessReviewHorizon {
  mode: 'live' | 'snapshot' | 'unresolved';
  permissionSnapshotId: number | null;
  snapshotLabel: string | null;
  snapshotUtcSavedOn: string | null;
  snapshotAsOfDate: string | null;
  message: string | null;
}

export const EMPTY_ACCESS_REVIEW_HORIZON: AccessReviewHorizon = {
  mode: 'live',
  permissionSnapshotId: null,
  snapshotLabel: null,
  snapshotUtcSavedOn: null,
  snapshotAsOfDate: null,
  message: null
};
